module.exports = __webpack_public_path__ + "img/dl-pr.8ff42968.png";